import { Component } from '@angular/core';
import { BsModalService } from 'ngx-bootstrap/modal';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { ProductService } from '@app/services/product/product.service';
import { IngredientService } from '@app/services/ingredient/ingredient.service';
import { HostService } from '@app/services/host/host.service';
import { forkJoin } from 'rxjs';
import { ToastrService } from 'ngx-toastr';
import { ConstService } from '@app/services/const/const.service';
@Component({
    moduleId: module.id,
    selector: 'personalize-menu-product',
    templateUrl: 'personalize-menu-product.html',
    styleUrls: ['personalize-menu-product.scss'],
    providers: [ProductService, IngredientService]
})
export class PersonalizeMenuProductComponent {
    activeStep = 1;
    product: any = {};
    host = "";
    filterOpt = "";
    filterSupp = "";
    unavComp = 0;
    unavSupp = 0;
    unavOpt = 0;
    optChecked: number = 0;
    loadAvatar: boolean;
    loading = true;
    labelOptions = "";
    constructor(
        public bsModalRef: BsModalRef,
        private hostService: HostService,
        private productService: ProductService,
        private modalService: BsModalService,
        private ingredientsService: IngredientService,
        private toastr: ToastrService,
        private constService: ConstService
    ) {
        this.labelOptions = this.constService.labelOptions,
        this.host = this.hostService.host2,
        this.optChecked = 0;
    }
    previous() {
        this.activeStep--;
    }
    next() {
        this.activeStep++;
    }
    ngOnInit() {
        setTimeout(
            () => {
                this.getOptions();
                this.getSupplements();
            }, 100
        )

        setTimeout(
            () => {
                forkJoin([
                    this.getCompositions(),
                    this.getOptions(),
                    this.getSupplements(),
                    this.getOptionsObligatoir()
                ]).subscribe(
                    (data: any[]) => {
                        this.loading = false;
                        this.product.compositions = data[0].map(p => {
                            p.label = p.text;
                            p.checked = true
                            return p;
                        })
                        this.unavComp = this.product.compositions.filter(comp => comp.disabled == 'true').length;
                        this.product.optionIngredients = data[1].map(p => {
                            p.label = p.text;
                            return p;
                        })
                        this.unavOpt = this.product.optionIngredients.filter(opt => opt.disabled == 'true').length;
                        this.product.selectedOpt = [];
                        this.product.supplements = data[2].map(p => {
                            p.label = p.text;
                            return p;
                        })
                        this.unavSupp = this.product.supplements.filter(supp => supp.disabled == 'true').length;
                        this.product.selectedSupp = [];
                        this.product.obligatoryIngredient = [];
                        this.product.obligatoryIngredient = data[3];
                    }
                )
            }, 100
        )
    }
    getCompositions() {
        return this.productService.getProductCompositions(this.product.element);
    }

    getOptions() {
        return this.productService.getProductOptionsIngredient(this.product.element)
    }
    getSupplements() {
        return this.productService.getProductSupplements(this.product.element)
    }
    getOptionsObligatoir() {
        return this.ingredientsService.getObligatoryIngredientOfProduct(this.product.element);
    }
    changeOption(opt) {
        if (opt.checked) {
            this.optChecked++;
        } else {
            this.optChecked--;
        }
    }
    valider() {
        let error = 0;
        let product = JSON.parse(JSON.stringify(this.product));
        if (product.custom) {
            product.selectedOpt = this.product.optionIngredients.filter(c => c.disabled == "false" && c.checked);
            if (product.selectedOpt.length == 0) {
                error++;
                let obligatoryIngredient=document.getElementById('obligatoryIngredient');
                obligatoryIngredient.scrollIntoView({ behavior: "smooth", block: "start" });
                this.toastr.error('Merci d\'ajouter les options', 'Attention', { positionClass: 'toast-top-center' });
                return;
            } else {
                product.obligatoryIngredient.forEach(cat => {
                    let array = product.selectedOpt.filter(o => o.category == cat.id);
                    if (error == 0 && array.length < cat.maxNbrIngOptions) {
                        error++;
                        let message = "Merci de selectionner au moins \r\n" + cat.maxNbrIngOptions + ' ingredient(s) de la categorie ' + cat.category;
                        this.toastr.error(message, 'Attention', { positionClass: 'toast-top-center' })
                        return;
                    }
                });
            }
        }
        if (error == 0) {
            let data: any = true;
            this.modalService.setDismissReason(data)
            this.bsModalRef.hide();
        }
    }

    ngAfterViewInit() {
        let content = document.getElementById('personnaliseproduct');
        let titles = document.getElementsByClassName('p-par');
        setTimeout(
            () => {
                let initoffset = Array.from(titles).map((title,i) => {
                    var rect = title.getBoundingClientRect();
                    var win = title.ownerDocument.defaultView;
                    return rect.top + win.pageYOffset-i*46
                });
                content.addEventListener('scroll', (event) => {
                    Array.from(titles).forEach((title, index) => {
                        let offset = initoffset[index];
                        var scrollTop = content.scrollTop;
                        if (scrollTop > offset) {
                            title.classList.add('fixed');
                        } else {
                            title.classList.remove('fixed');
                        }
                    });
                });
            }, 1000
        )
    }
}
